import React from "react";
import Link from "next/link";

const toc = [
  {
    topic: "Welche Skoda Modelle gibt es?",
    anchor: "welche-skoda-modelle-gibt-es",
  },
  {
    topic: "Doch welche sind die besten Skoda Leasing Angebote und welche Skoda Modelle passen am besten zu mir?",
    anchor: "doch-welche-sind-die-besten-skoda-leasing-angebote-und-welche-skoda-modelle-passen-am-besten-zu-mir",
  },
  {
    topic: "Welche Hybrid Skoda Modelle gibt es?",
    anchor: "welche-hybrid-skoda-modelle-gibt-es",
  },
  {
    topic: "Welche Skoda Modelle haben Allrad?",
    anchor: "welche-skoda-modelle-haben-allrad",
  },
  {
    topic: "Was ist Skoda Connect?",
    anchor: "was-ist-skoda-connect?",
  },
  {
    topic: "Was kostet eine Inspektion bei Skoda ?",
    anchor: "was-kostet-eine-inspektion-bei-skoda",
  },
  {
    topic: "Was umfasst die Skoda Garantie?",
    anchor: "was-umfasst-die-skoda-garantie",
  },
  {
    topic: "Was bedeutet Winterpaket bei Skoda?",
    anchor: "was-bedeutet-winterpaket-bei-skoda",
  },
  {
    topic: "Doch was steckt hinter der Marke Skoda?",
    anchor: "doch-was-steckt-hinter-der-marke-skoda",
  },
  {
    topic: "Woher stammt der Name Skoda?",
    anchor: "woher-stammt-der-name-skoda",
  },
  {
    topic: "Was bedeutet das Skoda Logo?",
    anchor: "was-bedeutet-das-skoda-logo",
  },
  {
    topic: "Zu wem gehört Skoda?",
    anchor: "zu-wem-gehort-skoda",
  },
];

export default () => (
  <div className="page-container page-container--tight px-5 mb-1">
    <h2 className="headline--4 mb-4">
      Skoda Leasing – Alle Modellneuheiten auf Null-Leasing sichern!
    </h2>
    <p className="mb-4">
      Sie mögen deutsche Qualität wenn es um Autos geht, aber wollen nicht den
      hohen Preis eines Mercedes oder Audis bezahlen? Dann werden Sie bei der
      Marke Skoda fündig. Das Skoda Leasing bietet Ihnen eine große Auswahl an
      verschiedenen Fahrzeugen mit einer hervorragenden Qualität, zu einem
      erschwinglichen Preis!
    </p>
    <ol className="mb-5 lg:mb-8">
      {toc.map(({ topic, anchor, subTopics }) => {
        if (subTopics && subTopics.length > 0) {
          return (
            <li key={anchor} className="text-secondary font-bold">
              {topic}
              <ul style={{ paddingLeft: "20px", listStyle: "disc" }}>
                {subTopics.map(({ topic, anchor }) => (
                  <li key={anchor} className="text-secondary font-bold">
                    <Link href={`#${anchor}`} className="link link--secondary">
                      {topic}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
          );
        }
        return (
          <li key={anchor} className="text-secondary font-bold">
            <Link href={`#${anchor}`} className="link link--secondary">
              {topic}
            </Link>
          </li>
        );
      })}
    </ol>
    <div
      id="welche-skoda-modelle-gibt-es"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Welche Skoda Modelle gibt es?
      </h3>
      <p className="mb-4">
        Aktuell gibt es 10 verschiedene Skoda Modelle, die in unterschiedlichen
        Ausführungen für Sie zur Verfügung stehen. Bei Null-Leasing finden Sie
        alle Skoda Modelle und Fahrzeugtypen. Von schnittigen Limousinen bis
        hin zu praktischen Kombis und geräumigen Skoda SUVs.
      </p>
    </div>
    <div
      id="doch-welche-sind-die-besten-skoda-leasing-angebote-und-welche-skoda-modelle-passen-am-besten-zu-mir"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Doch welche sind die besten Skoda Leasing Angebote und welche
        Skoda Modelle passen am besten zu mir?
      </h3>
      <p className="mb-4">
        “Skoda? Sind das nicht nur billige Audis, die von Familienvätern gefahren
        werden?” Die Antwort ist klar – Nein! Wer denkt das Skoda nichts kann,
        außer familienfreundliche Kombis herzustellen, der hat sich getäuscht.
        Das Skoda Leasing bietet verschiedene Skoda Modelle aller Klassen an.
      </p>
      <p className="mb-4">
        Wer stilvolle Klassiker liebt und ein Auge für Tradition hat, wird von dem
        Skoda Bestseller Skoda Octavia Kombi mehr als überzeugt sein. Er vereint
        mit seiner modernen Optik und Ausstattung das Beste aus der
        Vergangenheit, der Gegenwart und einer progressiven Zukunft. Durch
        seine 17’ Zoll Leichtmetallräder, seine chromfarbigen Zierleisten und
        seinen schwungvollen Konturen bietet der Kombi trotz seines Steilhecks
        genügend Sportlichkeit, um auch eingesessene Limousine-Fahrer zu
        überzeugen.
      </p>
      <p className="mb-4">
        Wer optisch jedoch trotzdem eine Limousine bevorzugt, dem ist mit der
        Limousinen Variante des Skoda Octavia zu helfen und bietet das
        limousinenübliche Stufenheck. Den Skoda Octavia gibt es als Kombi und
        auch als Limousine im Skoda Leasing bereits ab x€ im Monat bei
        Null-Leasing.
      </p>
      <p className="mb-4">
        Wem der Skoda Octavia doch nicht groß genug ist und sowohl mehr Luxus
        als auch Platz möchte, sollte den Skoda Superb in seine engere Auswahl
        nehmen. Der Skoda Superb ist das Flaggschiff der Skoda Modelle und
        bietet alle Top of the line Features der Marke Skoda. Der geräumige
        Alleskönner bietet mit seinen 4 Zylinder eine Leistung bis zu 280 Ps, in der
        2.0L Benziner Version des Fahrzeuges. Der Allrad und das 7-Gang DSG
        Getriebe bringen dabei die fast 300 Pferdestärken gekonnt auf die Straße.
        So beschleunigt der glanzvolle Allrad in nur 5,6 Sekunden von 0 auf 100
        km/H. Den Skoda Octavia und auch den Skoda Superb gibt es auch als
        Skoda Jahreswagen im Skoda Leasing.
      </p>
    </div>
    <div
      id="welche-hybrid-skoda-modelle-gibt-es"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Welche Hybrid Skoda Modelle gibt es?
      </h3>
      <p className="mb-4">
        Das erste Skoda Hybrid war der Skoda Citigo E, welcher jedoch nach
        seinem Auftritt 2011-2020 wieder eingestellt wurde. Der darauffolgende
        Hybrid aus dem Hause Skoda war der Skoda Superb iV. Dieser ist ein
        Plug-In-Hybrid, der in der Stadt bis zu 55 Kilometer rein elektrisch fahren
        kann.
      </p>
    </div>
    <div
      id="welche-skoda-modelle-haben-allrad"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Welche Skoda Modelle haben Allrad?
      </h3>
      <p className="mb-4">
        Ob Großstadtdschungel oder Serpentinen, die Allrad angetriebenen Skoda
        Modelle sind ihre treuesten Begleiter in egal welchem Terrain. Der
        beliebte Allradantrieb ist optional bei verschiedenen Skoda Modellen
        verfügbar. Zu den Modellen der 4x4 Reihe von Skoda gehört der Skoda
        Octavia, Skoda Karoq, Skoda Superb und der neue Skoda Kodiaq.
      </p>
      <p className="mb-4">
        Einer der wohl neuesten und beliebtesten Skoda Modelle ist der Skoda
        Kodiaq. Der neue SUV der Skoda Flotte ist der neue Stern am Leasing
        Himmel. Er punktet durch seine kraftvolle Erscheinung, seinem adaptiven
        Allradantrieb und seiner rundum Konnektivität, die einem eine leichte
        Kommunikation mit der internen Multimediaeinheit ermöglicht. Zusätzlich
        bietet Skoda mit dem Skoda Connect eine progressive Möglichkeit in
        einem konstanten Austausch mit seinem Fahrzeug zu stehen.
      </p>
    </div>
    <div
      id="was-ist-skoda-connect?"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Was ist Skoda Connect?
      </h3>
      <p className="mb-4">
        Skoda Connect ist eine Möglichkeit sich über eine App mit ihrem Fahrzeug
        zu verbinden. Mit Hilfe dieser App können Sie sämtliche Informationen
        über ihr Fahrzeug abrufen und mit dem Infotainmentsystem des
        Fahrzeuges kommunizieren. Des Weiteren bekommen Sie Updates zu
        Fahrdaten und Sicherheitsmeldungen, wie zum Beispiel, wenn Sie ihr
        Fahrzeug nicht abgeschlossen haben. Dies können Sie durch die Skoda
        Connect App nachträglich spielend leicht von ihrem Mobilen Endgerät
        machen.
      </p>
      <p className="mb-4">
        Diese App ist für alle neuen Skoda Modelle verfügbar und mit den meisten
        Mobilen Endgeräten und Smartwatches kompatibel.
      </p>
    </div>
    <div
      id="was-kostet-eine-inspektion-bei-skoda"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Was kostet eine Inspektion bei Skoda?
      </h3>
      <p className="mb-4">
        Eine Inspektion bei einem Skoda Fahrzeug kann zwischen 250€ und 750€
        kosten. Dies ist abhängig von den bereits gefahrenen Kilometern und dem
        jeweiligen Skoda Modell.
      </p>
      <p className="mb-4">
        Bei einem Skoda Leasing auf Null-leasing.com können Sie über die Skoda
        Bank für einen kalkulierbaren monatlichen Betrag das Wartung und
        Inspektionspaket dazu buchen. Das Wartung und Inspektionspaket
        beinhaltet Service jeglicher Art, sowie die Inspektion und die allgemeine
        Instandhaltung des Fahrzeuges. Das Skoda Wartung und Verschleißpaket
        inklusive Inspektion gibt es für das Skoda Neuwagen Leasing, aber auch
        für das Skoda Gebrauchtwagen Leasing.
      </p>
    </div>
    <div
      id="was-umfasst-die-skoda-garantie"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Was umfasst die Skoda Garantie?
      </h3>
      <p className="mb-4">
        Die Skoda Garantie gilt 2 Jahre lang bei Neuwagen. Diese kann jedoch mit
        der Skoda Garantieverlängerung um weitere 3 Jahre oder bis zu
        100.000/150.000 verlängert werden. Nach Ablauf der herkömmlichen
        Garantie gilt laut Skoda eine Toleranz von bis zu 3 Monaten, in denen
        Mängel von Skoda übernommen werden.
      </p>
      <p className="mb-4">
        So beinhaltet die Garantie bei einem Skoda Leasing Angebot das
        Abschleppen des Skodas, Pannenhilfe und weitere Service. Die
        Voraussetzung ist die Einhaltung der Wartung/Serviceintervalle.
      </p>
    </div>
    <div
      id="was-bedeutet-winterpaket-bei-skoda"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Was bedeutet Winterpaket bei Skoda?
      </h3>
      <p className="mb-4">
        Der Winter hat auch seine Nachteile, das Winterpaket von Skoda jedoch
        nicht. Mit dem Winterpaket von Skoda können Sie ihr Fahrzeug bereits im
        Skoda Konfigurator auf die düstere Jahreszeit vorbereiten. Es beinhaltet je
        nach Modell:
      </p>
      <ul className="mb-4">
        <li>Sitzheizung</li>
        <li>Beheizbare Außenspiegel</li>
        <li>Nebelscheinwerfer</li>
      </ul>
    </div>
    <div
      id="doch-was-steckt-hinter-der-marke-skoda"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Doch was steckt hinter der Marke Skoda?
      </h3>
      <p className="mb-4">
        125 Jahre Skoda. Hätten Sie gedacht, dass der tschechische
        Automobilhersteller des Volkswagenkonzerns eine längere Historie hat als
        Volkswagen an selbst? Es fing an mit der Herstellung von Fahrrädern 1895,
        als das Unternehmen von Václav Laurin und Václav Klement gegründet
        worden ist. Nachdem die beiden Brüder erst ein Motorrad entwickelten, in
        dem sie ihren Fahrrädern einen Hilfsmotor beifügten, folgte 1905 die
        Herstellung des ersten Automobils des tschechischen Unternehmens. Da
        das Unternehmen rasant am Wachsen war und ihre Produkte eine starke
        Nachfrage hatten, wurde 1907 die L&K zu einer Aktiengesellschaft und
        bekam der größte Automobilhersteller in Österreich und Ungarn.
      </p>
    </div>
    <div
      id="doch-was-steckt-hinter-der-marke-skoda"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Doch was steckt hinter der Marke Skoda?
      </h3>
      <p className="mb-4">
        125 Jahre Skoda. Hätten Sie gedacht, dass der tschechische
        Automobilhersteller des Volkswagenkonzerns eine längere Historie hat als
        Volkswagen an selbst? Es fing an mit der Herstellung von Fahrrädern 1895,
        als das Unternehmen von Václav Laurin und Václav Klement gegründet
        worden ist. Nachdem die beiden Brüder erst ein Motorrad entwickelten, in
        dem sie ihren Fahrrädern einen Hilfsmotor beifügten, folgte 1905 die
        Herstellung des ersten Automobils des tschechischen Unternehmens. Da
        das Unternehmen rasant am Wachsen war und ihre Produkte eine starke
        Nachfrage hatten, wurde 1907 die L&K zu einer Aktiengesellschaft und
        bekam der größte Automobilhersteller in Österreich und Ungarn.
      </p>
    </div>
    <div
      id="woher-stammt-der-name-skoda"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Woher stammt der Name Skoda?
      </h3>
      <p className="mb-4">
        Der Markenname Skoda stammt von dem böhmischen Ingenieur Emil
        Ritter von Skoda, der als Industrieller im Maschinenbaukonzern Skoda
        tätig war und diesem den Namen verliehen hat. Da das Laurin & Klement
        Unternehmen nach dem Ersten Weltkrieg stark geschwächt war und unter
        starken Einbußen gelitten hat, wurde dieses von dem
        Maschinenbaukonzern 1925 gekauft und bekam so den Namen Skoda.
        Seitdem tragen alle Skoda Modelle den Markennamen und das Logo
        welches aus einem Pfeil, einem Auge und Federn besteht.
      </p>
    </div>
    <div
      id="was-bedeutet-das-skoda-logo"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Was bedeutet das Skoda Logo?
      </h3>
      <p className="mb-4">
        Wie bereits beschrieben besteht das Skoda Logo aus drei
        Hauptkomponenten. Die Feder, welche den oberen Bestandteil des Logos
        darstellt, soll für die technische Entwicklung, die Erweiterung der
        Fertigungsprogramme und den globalen Absatz stehen. Der Pfeil
        symbolisiert die progressiven Produktionsmethoden und die hohe
        Produktivität, die das Unternehmen an den Tag bringt. Das letzte der drei
        Bestandteile des Logos, welche den mittleren Teil darstellt, ist das Auge.
        Dieses steht für Präzision, den Überblick und die Weitsichtigkeit der
        Marke. So soll das Logo die wichtigsten Werte der Marke nach außen
        tragen und die verschiedenen Skoda Modelle schmücken.
      </p>
    </div>
    <div
      id="zu-wem-gehort-skoda"
      className="pt-2 mb-10 lg:mb-12"
    >
      <h3 className="headline--6 mb-5 lg:mb-6">
        Zu wem gehört Skoda?
      </h3>
      <p className="mb-4">
        Der tschechische Automobilhersteller Skoda gehört zu Volkswagen. Im
        Jahr 1990 entschied sich die tschechische Regierung den
        Automobilkonzern an Volkswagen zu verkaufen, woraufhin 1991 die
        Skoda Auto Deutschland GmbH entstand. Mit der Entstehung der
        Tochtergesellschaft von Skoda entstand ebenfalls der Skoda Felicia,
        welcher der Vorreiter der heute bekannten Skoda Modelle Skoda Fabia
        und Skoda Octavia war.
      </p>
    </div>
  </div>
);
